window._Closeday = null;
window._Holiday = null;
if (window._ClosedayJsonURL) {
    fetch(window._ClosedayJsonURL)
    .then(r=>r.json())
    .then(r=>{
        window._Closeday = [];
        window._Holiday = [];
        // 休業曜日
        r.close_day.forEach(v => {
            window._Closeday.push("日月火水木金土".indexOf(v));
        });

        // 休業日
        window._Holiday = r.business_holiday;
    });
}

